/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import { Select, Upload, Button, List } from 'antd';
import { UploadOutlined, DeleteOutlined } from '@ant-design/icons';

import { DocumentTypes } from '../../queries/api/types';
import './UploadDocuments.less';
import { usePackagingFlow } from '../../context/PackagingFlowContext';

const { Option } = Select;

const UploadDocument = () => {
    const { uploadedFiles, setUploadedFiles } = usePackagingFlow();
    const [selectedDocumentType, setSelectedDocumentType] = useState<DocumentTypes>(DocumentTypes.LettreDeVoiture);

    const handleDocumentTypeChange = (value: DocumentTypes) => {
        setSelectedDocumentType(value);
    };

    const handleBeforeUpload = (file: File) => {
        const newFiles = file instanceof FileList ? Array.from(file) : [file];
        const filesWithTypes = newFiles.map((file) => ({
            file,
            type: selectedDocumentType,
        }));
        setUploadedFiles((prevFiles) => [...prevFiles, ...filesWithTypes]);
        return false; // Prevent default upload behavior
    };

    const handleDeleteFile = (index: number) => {
        setUploadedFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
    };

    return (
        <div className="upload-document-container bg-dash">
            <h3 className="font-bold font-18">Documents</h3>
            <div className="mb-16">
                <label htmlFor="document-type" className="block mb-8">
                    Type de documents
                </label>
            </div>
            <Select
                id="document-type"
                value={selectedDocumentType}
                onChange={(value) => handleDocumentTypeChange(value)}
            >
                {Object.values(DocumentTypes).map((docType) => (
                    <Option key={docType} value={docType}>
                        {docType}
                    </Option>
                ))}
            </Select>
            <Upload
                multiple={true}
                showUploadList={false}
                beforeUpload={handleBeforeUpload}
                accept=".jpg,.jpeg,.png,.pdf,.doc,.docx,.xls,.xlsx,.asc"
            >
                <Button icon={<UploadOutlined />} type="primary" className="ml-10">
                    Ajouter des documents
                </Button>
            </Upload>
            {uploadedFiles.length > 0 && (
                <div className="mt-24">
                    <h4>Pièces jointes</h4>
                    <List
                        className="mt-16"
                        size="small"
                        dataSource={uploadedFiles}
                        renderItem={(file, index) => (
                            <List.Item>
                                <span>
                                    <DeleteOutlined
                                        style={{ color: 'red', marginRight: 8, cursor: 'pointer' }}
                                        onClick={() => handleDeleteFile(index)}
                                        title="Supprimer"
                                    />
                                    {file.type}{' '}
                                    <a href="#" target="_blank" rel="noopener noreferrer" className="ml-10">
                                        {file.file.name}
                                    </a>
                                </span>
                            </List.Item>
                        )}
                    />
                </div>
            )}
        </div>
    );
};

export default UploadDocument;
